import GPTPlayground from "AppComponents/GPTPlayground";

export default store => ({
  path: ":conversationId",
  component: GPTPlayground,
});
